const AUTH_REDIRECT_BLOCKLIST = [
  '/login',
  '/login/confirmation',
  '/register',
  '/register/confirmation',
  '/register/resend-code',
  '/auth/callback',
  '/auth/google/callback',
  '/auth/google-calendar-callback',
  '/auth/gmail-callback',
  '/auth/outlook-callback',
  '/auth/outlook-calendar-callback',
  '/invite',
  '/unauthorized',
] as const;

const DEFAULT_AUTH_REDIRECT = '/organizations';

const decodeRedirectParam = (value: string | null): string | null => {
  if (!value) return null;
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

const normalizePathname = (value: string): string => value.split(/[?#]/)[0] || '';

const isBlockedRedirect = (pathname: string): boolean =>
  AUTH_REDIRECT_BLOCKLIST.some((blocked) => pathname.startsWith(blocked));

export const getAuthRedirectTarget = (
  search: string,
  currentPath: string,
  fallback: string = DEFAULT_AUTH_REDIRECT,
): string => {
  const params = new URLSearchParams(search);
  const rawRedirect = params.get('redirect') || params.get('returnUrl');
  const decoded = decodeRedirectParam(rawRedirect);

  if (!decoded || !decoded.startsWith('/')) {
    return fallback;
  }

  const targetPathname = normalizePathname(decoded);
  if (!targetPathname || targetPathname === currentPath) {
    return fallback;
  }

  if (isBlockedRedirect(targetPathname)) {
    return fallback;
  }

  return decoded;
};
